export const REPORT_NAME_CHARACTER_LIMIT = 100;
